/* eslint-disable no-underscore-dangle */


class WebRTCStats {
    private _receiver: RTCRtpReceiver;
    private _results: IStats[] = [];
    private _intervalIndex?: number;
    private readonly _intervalGetStats: number = 5000;

    constructor(receiver: RTCRtpReceiver) {
        this._receiver = receiver;
    }

    set receiver(_receiver: RTCRtpReceiver) {
        this._receiver = _receiver;
    }

    startGetStats = (callback: StatsCallbackType) => {
        this._intervalIndex = window.setInterval(this.getStats.bind(this, callback), this._intervalGetStats);
    };

    stopGetStats = () => {
        window.clearInterval(this._intervalIndex);
    };

    private calcSomethingPerSec = (oldStats: IStats, newStats: IStats, key: keyof IStats) => {
        const oldSomething = oldStats[key];
        const newSomething = newStats[key];
        if (typeof oldSomething === 'number' && typeof newSomething === 'number') {
            const deltaSomething = newSomething - oldSomething;
            const deltaTime = newStats.timestamp - oldStats.timestamp;
            return deltaSomething / deltaTime;
        }
        return 0;
    };

    private getStats = async (callback: StatsCallbackType) => {
        const stats = await this._receiver.getStats();
        stats.forEach((v) => {
            if (v.type === 'inbound-rtp') {
                const lastResult = this._results[this._results.length - 1];
                this._results.push({
                    ...v,
                });

                if (!lastResult) return;

                const result = {
                    bytesPerSec: this.calcSomethingPerSec(lastResult, v, 'bytesReceived'),
                    packetsPerSec: this.calcSomethingPerSec(lastResult, v, 'packetsReceived'),
                    framesDecodedPerSec: this.calcSomethingPerSec(lastResult, v, 'framesDecoded'),
                };

                callback(result);
            }
        });
    };
}


interface IStats extends RTCTransportStats{
    packetsReceived?: number;
    framesDecoded?: number;
    bytesReceived?: number;
    timestamp: number;
}

export interface IResultStats {
    bytesPerSec: number;
    packetsPerSec: number;
    framesDecodedPerSec: number;
}

type StatsCallbackType = (stats: IResultStats) => void;


export default WebRTCStats;
